module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAATCAYAAABlcqYFAAABQklEQVRIS+2UvytFYRjHP1+bkMJkkR/Jv0FKTEop/8JdLMKg/EgZpJRIXavRRBgQZbTIfmVjkXJvxkfP7T2c4bidcztn88zP8/m8z/d9e2VmJ0AfYORfAqoysyegI3/+L9ElFaClaMkkMA+MFCQ698zqZWYTwCrQm5PsHliQ9OpxXQJ3kraCbBxYBIablJ0BO5KezWwAKLnkEegEvoBNScdBNh1i7E8puwXWA7wNWAHmfNYlV8BQDFQDDiXtBdkYsNxgswtgTdKbmXX5QYGpGO/TJdfAYMJpP4B9SeXYZqWY7CZsXjGzbmAJmE3g1BpJon7frCxpN8hGgRdJDm8HtgF/oX9VKkk0/A4cSTowM898A5hJcV+ZJBHPH0hrCvhPEmniysBLbG1qk6zSf0mmxOpxPQA9mcYyNrvkFPCPrKiqfgPplplZJAwc7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/emailIcon.png
// module id = XYJn
// module chunks = 0